import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import {
  LearmoModalRef,
  LearmoModalService,
} from '../../services/learmo-modal.service';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoModalComponent implements OnInit {
  @Input() videoURL;
  @Input() videoTitle;
  @Input() videoPoster;

  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modalFooter') modalFooter: TemplateRef<any>;
  modalRef: LearmoModalRef;

  constructor(private modalService: LearmoModalService) {}

  open() {
    this.modalRef = this.modalService.open(this.modalContent, {
      title: this.videoTitle,
      footer: this.modalFooter,
      premium: true,
      size: 'xl', // Video usually needs space
      centered: true,
    });
  }

  ngOnInit(): void {}
}
